import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {BreadcrumbService, BreadcrumbUrls} from '../../../providers/services/breadcrumb.service';
import {UtilsService} from '../../../providers/services/utils.service';
import {PathNames, Paths} from '../../../../config/config';
import {LocalizeRouterService} from '@gilsdav/ngx-translate-router';
import {map, switchMap, tap} from 'rxjs/operators';
import {SearchService} from '../../../providers/services/search.service';
import {SeoService} from '../../../providers/services/seo.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, OnDestroy {

  private readonly subscriptions: Subscription = new Subscription();
  public readonly observableTerm = this.activatedRoute.params.pipe(map((params: Params) => params.term));
  results;

  constructor(
    private activatedRoute: ActivatedRoute,
    private breadcrumbService: BreadcrumbService,
    private router: Router,
    private utilsService: UtilsService,
    private localizeRouter: LocalizeRouterService,
    private searchService: SearchService,
    private seoService: SeoService
  ) {
    this.subscriptions.add(
      this.observableTerm.pipe(
        tap(() => this.results = undefined),
        switchMap((term: string) => this.searchService.search(term).pipe(map(response => Object({
          response,
          term
        }))))
      ).subscribe(({term, response}) => {
        this.breadcrumbService.next(BreadcrumbUrls.instance.addUrl({
          label: PathNames[Paths.Search],
          link: Paths.Search,
          args: [term]
        }));
        this.results = response.body;
        this.seoService.setTags(term);
      })
    );
    this.resetOnChangeLang();
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.breadcrumbService.reset();
    this.subscriptions.unsubscribe();
  }

  private resetOnChangeLang() {
    this.subscriptions.add(
      this.localizeRouter.routerEvents.subscribe(() => {
        this.router.navigateByUrl(this.localizeRouter.translateRoute(this.utilsService.getLink(Paths.Homepage)) as any);
      })
    );
  }

}
